export default "__VITE_ASSET__89xuBJVk__"